import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import { shouldShowNavbar } from "@/features/onboarding/onboardingGuard";

export function useNavbarVisibility(): boolean {
  const { isAuthenticated } = useAuth();
  const { pathname } = useLocation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const update = () => setVisible(shouldShowNavbar(isAuthenticated, pathname));
    update();

    const onStorage = () => update();
    const onCompleted = () => update();

    window.addEventListener("storage", onStorage);
    window.addEventListener("onboardingCompleted", onCompleted);
    return () => {
      window.removeEventListener("storage", onStorage);
      window.removeEventListener("onboardingCompleted", onCompleted);
    };
  }, [isAuthenticated, pathname]);

  return visible;
}
